import { FilterDefinition, Operators } from "@monolith-forensics/monolith-ui";
import { EventTypesAPI } from "./eventTypes.api";
import { GetEventTypesResponse } from "./eventTypes.types";

export const EventTypesFilterDefinition: FilterDefinition = {
  label: "Event Type",
  pluralLabel: "Event Types",
  dataField: "event_type_id",
  inputType: "multiselect",
  operators: [Operators.In, Operators.NIn],
  query: {
    initialPageParam: 1,
    cacheKey: ({ search }) =>
      JSON.stringify([...EventTypesAPI.queryKeys.infiniteList()]),
    loadPage: async ({ search }) => {
      const page = (await EventTypesAPI.get()) as GetEventTypesResponse;

      return {
        items:
          page?.map((eventType) => ({
            label: eventType.event_type,
            value: eventType.event_type_id,
            data: eventType,
          })) || [],
        nextPageParam: null,
      };
    },
  },
};
